import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { UnControlled as CodeMirror } from 'react-codemirror2';
// hint has to be imported from the js codemirror library
import CM from 'codemirror/lib/codemirror';

import 'codemirror/lib/codemirror.css';
// javascript mode contains the definition for token, if not imported
// the whole line will be recognized as a single token
import 'codemirror/mode/javascript/javascript';
import 'codemirror/theme/monokai.css';
import 'codemirror/theme/material.css';
import 'codemirror/addon/hint/show-hint.css';

import '../hint_methods/showHint';
import '../hint_methods/myHint';

import { updateText } from '../actions';

class Editor extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const options = {
      theme: 'monokai',
      lineWrapping: true
    };

    /* 
    give the classname for formating in css
    onKeyPress event works much better than onKeyUp, onKeyDown
    and onInput
    */
    const mirrorInstance = (
      <div>
        <CodeMirror
          className="ReactCodeMirror2"
          value={this.props.Text}
          options={options}
          height="100%"
          onKeyPress={(editor, event) => {
            editor.showHint(CM.hint.mine, this.props.Vocabularies);
          }}
          onChange={editor => {
            const cursor = editor.getCursor();
            this.props.updateText(editor.getValue());
            // set the cursor to the location before rerendering caused by
            editor.setCursor({ line: cursor.line, ch: cursor.ch });
          }}
        />
      </div>
    );

    return mirrorInstance;
  }
}

Editor.propTypes = {
  Text: PropTypes.string,
  Vocabularies: PropTypes.array,
  updateText: PropTypes.func
};

function mapStateToProps(state) {
  return {
    Text: state.Text,
    Vocabularies: state.Vocabularies
      ? [
          state.Vocabularies.unigram,
          state.Vocabularies.bigram,
          state.Vocabularies.trigram,
          state.Vocabularies.bigram_dictionary,
          state.Vocabularies.trigram_dictionary,
          state.Vocabularies.interpolation_model
        ]
      : null
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ updateText: updateText }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Editor);



// WEBPACK FOOTER //
// ./src/containers/editor.js